import dayjs from 'dayjs'
import { FC, useState } from 'react'
import { toast } from 'react-toastify'

import { updateUserNickname } from 'features/firebase/user-operations'
import { Rating } from 'features/game/components/rating'
import { useAuthenticatedUser } from 'features/user/auth-store'
import { DEFAULT_RATING } from 'features/user/elo-rating'
import { getUserInitials } from 'features/user/utils'

import { GreenButton } from 'shared/components'
import { Avatar, AvatarFallback, AvatarImage } from 'shared/components/ui/avatar'
import { Card } from 'shared/components/ui/card'
import { Input } from 'shared/components/ui/input'
import { Label } from 'shared/components/ui/label'
import { Separator } from 'shared/components/ui/separator'

export const PlayerProfile: FC = () => {
  const { user, player } = useAuthenticatedUser()
  const [playerNickname, setPlayerNickname] = useState(player.nickname ?? '')

  const savePlayerNickName = async () => {
    await updateUserNickname(user.uid, playerNickname)
    toast.success('Nickname updated!')
  }

  return (
    <Card className="mx-auto my-10 flex w-11/12 flex-col gap-6 p-6 lg:w-[800px]">
      <div className="flex w-full items-center justify-between gap-5">
        <div className="flex items-center gap-2">
          <Avatar>
            <AvatarImage src={user.photoURL || undefined} />
            <AvatarFallback>{getUserInitials(user.displayName)}</AvatarFallback>
          </Avatar>
          {user.displayName}
        </div>
        <div className="flex flex-col space-y-2 text-gray-400">
          Joined
          <span className="text-black">{dayjs(user.metadata.creationTime).format('D MMM YYYY')}</span>
        </div>
      </div>
      <div>
        <Label htmlFor="nickname">Game nickname</Label>
        <div className="flex w-full items-center gap-4 sm:w-1/2">
          <Input
            value={playerNickname}
            onChange={e => setPlayerNickname(e.target.value)}
            id="nickname"
            type="text"
            placeholder="Fire killer"
          />
          <GreenButton text="Save" onClick={savePlayerNickName} />
        </div>
      </div>
      <Separator />
      <div className="flex items-center justify-center gap-5 text-xl font-bold">
        Rating
        <Rating rating={player.rating || DEFAULT_RATING} />
      </div>
    </Card>
  )
}
